export var QUERY = "QUERY";
export var QUERY_RESULTS = "QUERY_RESULTS";
export var SEARCHING = "SEARCHING";
